import * as EventConstants from 'constants/EventConstants';
import {BioentitySummary} from 'folder-items/FileConstants';
import AppDispatcher from 'lib/Dispatcher';
import {ManagedModelType} from 'models/ManagedModelDefinitions';
import * as ManagedModelsReduxActions from 'models/ManagedModelsReduxActions';
import * as ModelActions from 'redux-stores/ModelActions';
import {getStore} from 'redux-stores/Store';
import {populateSearchParamWithDefaultSort} from 'search/getSortsOrDefault';
import {SearchParams, SearchResults, SearchType} from 'search/SearchConstants';

import * as BioentityDAO from './BioentityDAO';
import {BioentitySearchResponse} from './BioentityDAO';

async function listBioentitiesCompleteResponse(searchParams: SearchParams): Promise<BioentitySearchResponse> {
  const searchParamsWithDefault = populateSearchParamWithDefaultSort(searchParams, SearchType.BIOENTITIES);
  const {
    searchId,
    status,
    ids,
    total,
    isExact,
    timedOut,
    fileSummariesById,
    permissionsByModelId,
    bioentityAliasInfosByBioentityId,
    correlationId,
    scoresById,
    groups,
    nextToken,
  } = await BioentityDAO.listBioentities(searchParamsWithDefault);
  getStore().dispatch(
    ManagedModelsReduxActions.modelFetched(ManagedModelType.PERMISSIONS_BY_ITEM_ID, permissionsByModelId)
  );
  getStore().dispatch(ModelActions.filesFetchCompleted(fileSummariesById));
  AppDispatcher.dispatch({
    actionType: EventConstants.BIOENTITY_ALIAS_INFO_LOAD_COMPLETED,
    bioentityAliasInfosById: bioentityAliasInfosByBioentityId,
  });
  return {
    searchId,
    status,
    ids,
    groupItemIds: [],
    total,
    isExact,
    timedOut,
    fileSummariesById,
    permissionsByModelId,
    bioentityAliasInfosByBioentityId,
    correlationId,
    scoresById,
    groups,
    nextToken,
  };
}

export interface BioentitySummarySearchResponse extends SearchResults {
  fileSummariesById: {[id: string]: BioentitySummary};
}

export async function listBioentitiesWithSummaries(
  searchParams: SearchParams
): Promise<BioentitySummarySearchResponse> {
  const {searchId, status, ids, total, isExact, timedOut, fileSummariesById, scoresById, groups, nextToken} =
    await listBioentitiesCompleteResponse(searchParams);
  return {
    searchId,
    status,
    ids,
    groupItemIds: [],
    total,
    isExact,
    timedOut,
    fileSummariesById,
    scoresById,
    groups,
    nextToken,
  };
}
